module.exports = __webpack_public_path__ + "img/sCrazyMkDx_193x205.021dd700.png";